import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const WorkDescriptionSection = ({ formData, onFormChange, errors }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name="FileEdit" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Work Description</h2>
          <p className="text-sm text-muted-foreground">Provide detailed information about the work to be performed</p>
        </div>
      </div>
      <div className="space-y-4">
        <Input
          label="Work Title"
          type="text"
          placeholder="e.g., Electrical Panel Maintenance"
          value={formData?.workTitle}
          onChange={(e) => onFormChange('workTitle', e?.target?.value)}
          error={errors?.workTitle}
          required
        />

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Detailed Description <span className="text-error">*</span>
          </label>
          <textarea
            value={formData?.workDescription}
            onChange={(e) => onFormChange('workDescription', e?.target?.value)}
            placeholder="Describe the work to be performed, including specific tasks, equipment to be used, and any special considerations..."
            rows={5}
            className={`w-full px-4 py-3 rounded-lg border ${
              errors?.workDescription ? 'border-error' : 'border-border'
            } bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors resize-none`}
          />
          {errors?.workDescription && (
            <p className="mt-1 text-sm text-error">{errors?.workDescription}</p>
          )}
          <p className="mt-1 text-xs text-muted-foreground">Minimum 50 characters required</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Estimated Duration"
            type="text"
            placeholder="e.g., 4 hours"
            value={formData?.estimatedDuration}
            onChange={(e) => onFormChange('estimatedDuration', e?.target?.value)}
            error={errors?.estimatedDuration}
            required
          />

          <Input
            label="Number of Workers"
            type="number"
            placeholder="e.g., 3"
            value={formData?.numberOfWorkers}
            onChange={(e) => onFormChange('numberOfWorkers', e?.target?.value)}
            error={errors?.numberOfWorkers}
            required
            min="1"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Start Date & Time"
            type="datetime-local"
            value={formData?.startDateTime}
            onChange={(e) => onFormChange('startDateTime', e?.target?.value)}
            error={errors?.startDateTime}
            required
          />

          <Input
            label="End Date & Time"
            type="datetime-local"
            value={formData?.endDateTime}
            onChange={(e) => onFormChange('endDateTime', e?.target?.value)}
            error={errors?.endDateTime}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default WorkDescriptionSection;